<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    公明广场站<br>
站点介绍<br>
公明广场站位于深圳市光明区松白公路与长春路交叉路口西侧，车站主体呈东西走向，东接红花山站，西接合水出入口站。 车站色彩基调以白色为主，为地下二层车站，地下一层为站厅站台同层，地下二层为为换乘层，站台形式为侧式站台。车站共设有4个出入口，临近公明汽车站、公明广场、公明中学，周边以住宅、商业为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:31	23:11	6号线	3分24秒	6分20秒<br>
松岗	06:14	00:00	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:31	23:11	6号线	4分45秒	6分钟<br>
松岗	06:14	00:00	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:31	00:11	6号线	4分45秒	6分钟<br>
松岗	06:14	01:00	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
松白路北侧（东）、公明广场、B出入口<br><br>
C出入口:<br>
松白路南侧（西）、公明汽车站<br><br>
D出入口:<br>
松白路南侧（东）、大仟里<br><br>
公交换乘信息<br><br>
<br>
公交站名： A出入口｜公明汽车站<br>
M234、M415、M548
<br>
公交站名： B出入口｜三和百货<br>
E35、M234、M337、M410、M415、M436、M548、M549、M215、B868、M218、M216、M495<br>
<br>
公交站名： C出入口｜松白金安路口<br>
M490、M495、K578、B889、M549<br>
<br>
公交站名： D出入口｜公明汽车站1<br>
E35、M234、M337、M415、M548、M512<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>